export const REQUEST_GRANTS = 'dt/auth/REQUEST_GRANTS';
export const RECEIVE_GRANTS = 'dt/auth/RECEIVE_GRANTS';
export const REQUEST_MEMBER_TYPES = 'dt/auth/REQUEST_MEMBER_TYPES';
export const RECEIVE_MEMBER_TYPES = 'dt/auth/RECEIVE_MEMBER_TYPES';
export const REQUEST_MEMBERS = 'dt/auth/REQUEST_MEMBERS';
export const RECEIVE_MEMBERS = 'dt/auth/RECEIVE_MEMBERS';
export const RECEIVE_TENANT_USERS = 'dt/auth/RECEIVE_TENANT_USERS';
export const CREATE_MEMBER_AND_CONNECTION = 'dt/auth/CREATE_MEMBER_AND_CONNECTION';
export const UPDATE_MEMBER_AND_CONNECTION = 'dt/auth/UPDATE_MEMBER_AND_CONNECTION';
export const UPDATE_MEMBER = 'dt/auth/UPDATE_MEMBER';
export const UPDATE_MEMBERS = 'dt/auth/UPDATE_MEMBERS';
export const DELETE_MEMBER = 'dt/auth/DELETE_MEMBER';
export const CREATE_MEMBER_SUCCESS = 'dt/auth/CREATE_MEMBER_SUCCESS';
export const DELETE_MEMBER_CONNECTION = 'dt/auth/DELETE_MEMBER_CONNECTION';
export const REQUEST_INVITATIONS = 'dt/auth/REQUEST_INVITATIONS';
export const RECEIVE_INVITATIONS = 'dt/auth/RECEIVE_INVITATIONS';
export const CREATE_INVITATIONS = 'dt/auth/CREATE_INVITATIONS';
export const UPDATE_INVITATION = 'dt/auth/UPDATE_INVITATION';
export const UPDATE_INVITATIONS = 'dt/auth/UPDATE_INVITATIONS';
export const DELETE_INVITATION = 'dt/auth/DELETE_INVITATION';
export const DELETE_INVITATION_SUCCESS = 'dt/auth/DELETE_INVITATION_SUCCESS';
export const AUTHORIZE_USER = 'dt/auth/AUTHORIZE_USER';
export const CHECKED_INVITATIONS = 'dt/auth/CHECKED_INVITATIONS';
export const REQUEST_SERVICE_ACCOUNTS = 'dt/auth/REQUEST_SERVICE_ACCOUNTS';
export const RECEIVE_SERVICE_ACCOUNTS = 'dt/auth/RECEIVE_SERVICE_ACCOUNTS';
export const TRANSFER_SERVICE_ACCOUNTS = 'dt/auth/TRANSFER_SERVICE_ACCOUNTS';

export const requestGrants = (oid, callback) => ({
  type: REQUEST_GRANTS,
  oid,
  callback,
});

export const receiveGrants = (grants) => ({
  type: RECEIVE_GRANTS,
  grants,
});

export const requestMemberTypes = () => ({
  type: REQUEST_MEMBER_TYPES,
});

export const receiveMemberTypes = (memberTypes) => ({
  type: RECEIVE_MEMBER_TYPES,
  memberTypes,
});

export const requestMembers = (objectId, indexUsers = false) => ({
  type: REQUEST_MEMBERS,
  objectId,
  indexUsers,
});

export const receiveMembers = (members) => ({
  type: RECEIVE_MEMBERS,
  members,
});

export const receiveTenantUsers = (tenantUsers) => ({
  type: RECEIVE_TENANT_USERS,
  tenantUsers,
});

export const createMemberAndConnection = (data, indexUsers = false) => ({
  type: CREATE_MEMBER_AND_CONNECTION,
  data,
  indexUsers,
});

export const updateMemberAndConnection = (data, indexUsers = false) => ({
  type: UPDATE_MEMBER_AND_CONNECTION,
  data,
  indexUsers,
  isUpdate: true,
});

export const updateMember = (data) => ({
  type: UPDATE_MEMBER,
  data,
});

export const updateMembers = (data, user) => ({
  type: UPDATE_MEMBERS,
  data,
  user,
});

export const deleteMember = (memberId) => ({
  type: DELETE_MEMBER,
  memberId,
});

export const createMemberSuccess = (members) => ({
  type: CREATE_MEMBER_SUCCESS,
  members,
});

export const deleteMemberConnection = (id, userId) => ({
  type: DELETE_MEMBER_CONNECTION,
  id,
  userId,
});

export const requestInvitations = (org) => ({
  type: REQUEST_INVITATIONS,
  org,
});

export const receiveInvitations = (invitations) => ({
  type: RECEIVE_INVITATIONS,
  invitations,
});

export const createInvitations = (data) => ({
  type: CREATE_INVITATIONS,
  data,
});

export const updateInvitation = (data, invitationId) => ({
  type: UPDATE_INVITATION,
  data,
  invitationId,
});

export const updateInvitations = (invitations) => ({
  type: UPDATE_INVITATIONS,
  invitations,
});

export const deleteInvitation = (invitationId) => ({
  type: DELETE_INVITATION,
  invitationId,
});

export const deleteInvitationSuccess = (invitationId) => ({
  type: DELETE_INVITATION_SUCCESS,
  invitationId,
});

export const authorizeUser = (data) => ({
  type: AUTHORIZE_USER,
  data,
});

export const setCheckedInvitations = (checkedAt) => ({
  type: CHECKED_INVITATIONS,
  checkedInvitations: checkedAt,
});

export const requestServiceAccounts = () => ({
  type: REQUEST_SERVICE_ACCOUNTS,
});

export const receiveServiceAccounts = (serviceAccounts) => ({
  type: RECEIVE_SERVICE_ACCOUNTS,
  serviceAccounts,
});

export const transferServiceAccounts = (fromId, toId) => ({
  type: TRANSFER_SERVICE_ACCOUNTS,
  fromId,
  toId,
});
